export const SET_CERTFOCUS_NOTES_ERROR = 'SET_CERTFOCUS_NOTES_ERROR';
export const SET_CERTFOCUS_FETCHING_NOTES = 'SET_CERTFOCUS_FETCHING_NOTES';
export const SET_CERTFOCUS_NOTES_LIST = 'SET_CERTFOCUS_NOTES_LIST';
export const SET_CERTFOCUS_NOTES_ROLES_POSSIBLE_VALUES = 'SET_CERTFOCUS_NOTES_ROLES_POSSIBLE_VALUES';

export const SET_CERTFOCUS_SAVING_NOTE_ERROR = 'SET_CERTFOCUS_SAVING_NOTE_ERROR';
